// This should move to BE
export const generalErrorMessage = 'Something went wrong. Try again, or contact Hero support.';
const authMessage = 'Something went wrong. Try logging out, and then log back in.';
const heroDisconnectedMessage = 'Hero disconnected. Reconnect WI-FI.';
const heroFullMessage = 'Hero is full. You can still track items outside of Hero.';
const duplicatePillMessage = 'You already have this medication setup!';
const verifyActivateMessage = 'We were unable to verify your account. Your link may have been broken or expired.';
const creditCardMessage = 'Please check your credit card information and try again.';
const beErrors = {
    // auth errors
    auth_error: authMessage,
    session_discarded: authMessage,
    no_session_id: authMessage,
    session_not_found: authMessage,
    session_expired: authMessage,
    session_closed: authMessage,
    invalid_session_user: authMessage,
    error_oauth_failed: authMessage,
    invalid_grant: "Oops, this email or password isn't right.",
    no_such_user: 'Can’t find the user',
    // account errors
    blocked_temporarily: 'Your account has been temporarily locked out. Please try again in 5 minutes.',
    blocked_permanently: 'Your account has been permanently locked out. Please call 855-855-9962 for Customer Support.',
    user_does_not_exist: 'User is not found',
    could_not_find_user: 'Could not find user',
    could_not_find_account: 'Could not find account',
    could_not_find_subscription: 'Could not find subscription',
    wrong_old_password: 'Entered password is incorrect. Please try again.',
    // device errors
    no_device_paired: 'No device paired with account.',
    hero_offline: heroDisconnectedMessage,
    hero_disconnected: heroDisconnectedMessage,
    not_demo_device: 'This is not a demo device.',
    // pill errors
    hero_device_full: heroFullMessage,
    no_free_slots: heroFullMessage,
    hero_full: heroFullMessage,
    already_exists: duplicatePillMessage,
    duplicate_pill_names: duplicatePillMessage,
    mismatch_error: 'Please confirm removal of the pill on Hero before adding it to your schedule.',
    times_are_the_same: 'New time is the same as existing.',
    // phone number errors
    invalid_caregiver_mobile: 'Invalid phone number',
    invalid_mobile: 'Invalid mobile number',
    app_download_sms_url_not_defined: 'There has been some problem. Contact support.',
    failed_sending_sms: 'Failed sending sms.',
    failed_sending_code: 'Failed sending code.',
    mobile_same_as_existing: 'We already have this number in our records',
    wrong_pin: 'You have entered wrong PIN code.',
    // email errors
    no_email: 'No email',
    no_email_found: 'Sorry, we don’t recognize this email. Try again.',
    invalid_email: 'Provided email address is invalid.',
    email_same_as_existing: 'Email same as existing.',
    email_taken: 'Email already taken.',
    failed_sending_mail: 'Failed sending email',
    // verify email / activate user
    no_activation_code: verifyActivateMessage,
    user_not_found: verifyActivateMessage,
    activation_code_does_not_match: verifyActivateMessage,
    activation_code_expired: verifyActivateMessage,
    wrong_activation_code: verifyActivateMessage,
    // pin errors
    pin_not_found: 'Oops, that code doesn’t look right. Try again.',
    invalid_pin_format: 'Oops, that code doesn’t look right. Try again.',
    pin_expired: 'This code has expired. Check Hero for a new one.',
    // other
    request_error: 'Request error',
    invalid_json_format: 'Pill data that is entered is invalid',
    old_config_not_found: 'To save your changes, press the center button on Hero.',
    connection_error: 'There’s some trouble connecting to the server.',
    unknown_error: generalErrorMessage,
    // backoffice - generic errors
    no_id: 'Invalid request.',
    ambiguous: 'Invalid request.',
    invalid_id: 'Invalid request.',
    invalid_external_serial: 'Invalid request.',
    missing_identifier: 'Invalid request.',
    not_found: 'Requested object not found.',
    object_not_found: 'Requested object not found.',
    // backoffice - membership errors
    invalid_subscription: 'Could not find membership.',
    invalid_plan: 'Invalid membership plan.',
    plan_change_failed: 'Could not change Stripe subscription plan.',
    invalid_stripe_subscription: 'Could not retrieve Stripe subscription.',
    transaction_error: 'Stripe transaction error.',
    invalid_payment_token: 'Missing Stripe token.',
    stripe_token_invalid: 'Invalid Stripe token.',
    not_eligible_for_refund: 'Membership not eligible for refund.',
    not_eligible_for_cancellation_fee: 'Membership not eligible for cancellation fee.',
    cancellation_fee_calc_error: 'Error calculating cancellation fee.',
    invalid_cancellation_type: 'Invalid cancellation type.',
    missing_zendesk_ticket_number_field: 'Missing required field Zendesk ticket number.',
    missing_reason_code_field: 'Missing required field Reason of cancellation.',
    missing_reason_sub_code_field: 'Missing required field Sub-Reason.',
    field_reason_code_has_unexpected_value: 'Invalid reason of cancellation.',
    field_reason_sub_code_has_unexpected_value: 'Invalid sub-reason.',
    missing_notes_field: 'Missing required field Notes.',
    missing_exception_approver_field: 'Missing required field Exception approver.',
    missing_exception_number_field: 'Missing required field Exception number.',
    missing_approver_notes_field: 'Missing required field Approver notes.',
    invalid_alert_id: 'Could not find alert.',
    subscription_not_cancelled: 'Membership not cancelled.',
    payment_failed: 'Payment failed.',
    downgrade_failed: 'Plan downgrade not available. Member is still in the first year of commitment',
    // backoffice - organization errors
    enrollment_not_found: 'Could not find organization enrollment.',
    member_not_found: 'Could not find organization member.',
    invalid_member_status: 'Current member status does not allow the requested operation.',
    invalid_fulfillment_status: 'Something went wrong. Seems like the order has been filled in the meantime. Please start over :(',
    failed_cancelling_order: 'Error cancelling order.',
    invalid_organization: 'Could not find organization.',
    // backoffice - order errors
    error_creating_checkout: 'Error initiating order.',
    invalid_order: 'Could not find order.',
    // backoffice - rma errors
    previous_rma_not_completed: 'Another RMA request already exists.',
    // backoffice - rtm errors
    already_applied: 'RTM application already submitted.',
    // stripe errors
    card_declined: creditCardMessage,
    authentication_required: creditCardMessage,
    approve_with_id: creditCardMessage,
    call_issuer: creditCardMessage,
    card_not_supported: creditCardMessage,
    card_velocity_exceeded: creditCardMessage,
    currency_not_supported: creditCardMessage,
    do_not_honor: creditCardMessage,
    do_not_try_again: creditCardMessage,
    duplicate_transaction: creditCardMessage,
    expired_card: creditCardMessage,
    fraudulent: creditCardMessage,
    generic_decline: creditCardMessage,
    incorrect_number: creditCardMessage,
    incorrect_cvc: creditCardMessage,
    incorrect_pin: creditCardMessage,
    incorrect_zip: creditCardMessage,
    insufficient_funds: `${creditCardMessage} If the problem persists, contact your card issuer.`,
    invalid_account: creditCardMessage,
    invalid_amount: creditCardMessage,
    invalid_cvc: creditCardMessage,
    invalid_expiry_year: creditCardMessage,
    invalid_number: creditCardMessage,
    invalid_pin: creditCardMessage,
    issuer_not_available: creditCardMessage,
    lost_card: creditCardMessage,
    merchant_blacklist: creditCardMessage,
    new_account_information_available: creditCardMessage,
    no_action_taken: creditCardMessage,
    not_permitted: creditCardMessage,
    offline_pin_required: creditCardMessage,
    online_or_offline_pin_required: creditCardMessage,
    pickup_card: creditCardMessage,
    pin_try_exceeded: creditCardMessage,
    processing_error: creditCardMessage,
    reenter_transaction: creditCardMessage,
    restricted_card: creditCardMessage,
    revocation_of_all_authorizations: creditCardMessage,
    revocation_of_authorization: creditCardMessage,
    security_violation: creditCardMessage,
    service_not_allowed: creditCardMessage,
    stolen_card: creditCardMessage,
    stop_payment_order: creditCardMessage,
    testmode_decline: creditCardMessage,
    transaction_not_allowed: creditCardMessage,
    try_again_later: creditCardMessage,
    withdrawal_count_limit_exceeded: creditCardMessage
};
export default beErrors;
//# sourceMappingURL=beErrorMessages.js.map